import img from "app/img";
import { getItemWithExpiration } from "./localStorageUtil";
import { VideoTypeDataType } from "services/apis/cnt/video-type-api";
import { VideoAlbumDataType } from "services/apis/cnt/video-album-api";
import { VideoTagDataType } from "services/apis/cnt/video-tag-api";

export const getCateCover = (cateIndex: number) => {
  return img.cateCover[cateIndex][new Date().getDay() % 5];
};

export const getCateCoverByName = (typeName: String) => {
  let _index = 0;
  let flag = false;
  getItemWithExpiration("cachedCategory")?.forEach(
    (item: VideoTypeDataType, index: number) => {
      if (typeName === item.typeName) {
        _index = index;
        flag = true;
        return;
      }
    }
  );
  return flag ? getCateCover(_index) : null;
};

export const getAlbumCover = (albumIndex: number) => {
  return img.albumCover[albumIndex][new Date().getDay() % 5];
};

export const getAlbumCoverByName = (albumName: String) => {
  let _index = 0;
  let flag = false;
  getItemWithExpiration("cachedAlbum")?.forEach(
    (item: VideoAlbumDataType, index: number) => {
      if (albumName === item.albumName) {
        _index = index;
        flag = true;
        return;
      }
    }
  );
  return flag ? getAlbumCover(_index) : null;
};

export const getTagCover = (albumIndex: number) => {
  return img.albumCover[albumIndex][new Date().getDay() % 5];
};

export const getTagCoverByName = (tagName: String) => {
  let _index = 0;
  let flag = false;
  getItemWithExpiration("cachedTag")?.forEach(
    (item: VideoTagDataType, index: number) => {
      if (tagName === item.tagName) {
        _index = index;
        flag = true;
        return;
      }
    }
  );
  return flag ? getTagCover(_index) : null;
};
